import { ALLOWLIST, type FeedbackEvent } from './allowlist'

/**
 * The recent-events ring (SA-1304): at most `ring.max_events`, none older than `ring.max_age_ms`,
 * oldest first. Pure: every call returns a new array.
 */

export function pruneEvents(events: readonly FeedbackEvent[], now: number): FeedbackEvent[] {
  const oldest = now - ALLOWLIST.ring.max_age_ms
  const fresh = events.filter((event) => event.at >= oldest)
  return fresh.slice(Math.max(0, fresh.length - ALLOWLIST.ring.max_events))
}

export function pushEvent(events: readonly FeedbackEvent[], event: FeedbackEvent, now: number): FeedbackEvent[] {
  return pruneEvents([...events, event], now)
}
